module.exports = {
    dynamic: {
        CommodityCodeIsInvalid: 'Commodity code is invalid',
        CommodityCodeOrQueryIsRequired: 'Commodity code or search query is required',
        QueryIsTooShort: 'Search query is too short',
        QueryIsRequired: 'Search query is required',
    }
};